import { FinancialAccountNode } from '../orgs/interfaces';
import { getAccountStatus } from './accountStatus';
import logger from '../../util/logger';

const ERROR_MESSAGE =
  'If any additional information is required, we will contact you directly.';

export const verifyFinancialAccount = async (
  financialAccount: FinancialAccountNode,
): Promise<string | void> => {
  if (financialAccount.processor === undefined) {
    throw Error(
      `financialAccount ${financialAccount.finAcctId} is missing processor field.`,
    );
  }
  logger(
    `about to check financialAccount status of ${financialAccount.finAcctId}`,
  );
  try {
    const accountStatus = await getAccountStatus(
      financialAccount.processor.toLowerCase() as VaultProvider,
      financialAccount.acctId,
      financialAccount.applicationId,
    );
    logger('accountStatus', false, accountStatus);
    if (!accountStatus.valid) {
      logger('account is invalid', true);
      return ERROR_MESSAGE;
    }
  } catch {
    return ERROR_MESSAGE;
  }
};
